import { render, staticRenderFns } from "./LeadsLandingPage.vue?vue&type=template&id=b0abb3c2&scoped=true"
import script from "./LeadsLandingPage.vue?vue&type=script&lang=js"
export * from "./LeadsLandingPage.vue?vue&type=script&lang=js"
import style0 from "./LeadsLandingPage.vue?vue&type=style&index=0&id=b0abb3c2&prod&lang=css"
import style1 from "./LeadsLandingPage.vue?vue&type=style&index=1&id=b0abb3c2&prod&lang=scss&scoped=true"
import style2 from "./LeadsLandingPage.vue?vue&type=style&index=2&id=b0abb3c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0abb3c2",
  null
  
)

export default component.exports